<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<app-header></app-header>
<section class="supplier_fuso_tabs mar-top-20">
  <ul class="nav nav-tabs" role="tablist">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#newNextProcess" role="tab" #newProcessNav>{{'New Next Process' | translate}}</a>
    </li>
    <li class="nav-item">
      <a class="nav-link " data-toggle="tab" href="#NextProcess" role="tab" #unlistNav>{{'Next Process DB' |
        translate}}</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#DeletedNextProcess" role="tab" #createNav>{{'Deleted Next Process DB' | translate}}</a>
    </li>
  </ul>
</section>
<div class="tab-content">
  <div class="tab-pane active" id="newNextProcess" #newProcessPane>
    <section class="parts_container mar-btm-40">
      <div class="row_title">{{'New Next Process' | translate}}</div>
    </section>
    <!-- <section class="part_search_bar row">
      <div class="col-md-6">
        <input class="searchBar" [(ngModel)]="searchText" placeholder="Search Next Process">
        <input *ngIf="config.filtering" placeholder="{{'filter all columns' | translate}}" [ngTableFiltering]="config.filtering"
          class="searchBar" (tableChanged)="onChangeTable(config)" />
      </div> -->
    <!-- <div class="offset-md-2 col-md-4">
            <button class="row_title_export btn btn-dark" (click)="exportNewNPcsv()">
              Export&nbsp;New&nbsp;Next process
            </button>
          </div> -->

    <!-- </section> -->

    <section class="part_search_bar">
      <div class="row no-mar-lr">

        <div class="col-md-4"></div>
        <div class="col-md-4 search_input input-group custom-search-form  pad-top-30" >
          <input type="text" class="form-control"  class="form-control"
            placeholder="{{'filter all columns' | translate}}" [(ngModel)]="srchValue" >
          <span class="input-group-btn">
            <button class="btn btn-light" type="button" (click)="onChangeTable(config)">
              {{'Search' | translate}}
            </button>
          </span>
        </div>
        <div class="col-md-4"></div>

      </div>
    </section>

    <div class="row ">
      <div class="offset-md-1 col-md-10">
        <pagination *ngIf="config.paging" class="pagination-sm pull-right pad-top-10" [(ngModel)]="page" [totalItems]="length"
          [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)"
          (numPages)="numPages = $event">
        </pagination>
        <!-- <ng-table [config]="config" (tableChanged)="onChangeTable(config)" (cellClicked)="navigateTab($event)" [rows]="rows" [columns]="columns">
              </ng-table> -->
        <table class="table table-bordered text-centered" *ngIf="missingNPData !== undefined">
          <tr class="bg-gray">
            <th class="text-center">{{'LINENUMBER' | translate}}</th>
            <th class="text-center">{{'Plant Name' | translate}}</th>
            <th class="text-center">{{'Process Name [JP]' | translate}}</th>
            <th class="text-center">{{'Process Name [EN]' | translate}}</th>
            <th class="text-center">{{'Add Next Process' | translate}}</th>
          </tr>
          <tbody *ngFor="let data of missingNPData">
            <tr>
              <td class="text-center">{{data.lineNumber}}</td>
              <td class="text-center">
                <select class="form-control" (change)="onChange($event.target.value)">
                  <option value="Select">{{'Select' | translate}}</option>
                  <option *ngFor="let opt of operationsGNumberList" value={{opt}}>
                    {{opt}}
                  </option>
                </select>
              </td>
              <td class="text-center">
                <input class="form-control" (change)="onChangeJP($event.target.value)" placeholder="{{'Process Name [JP]' | translate}}" />
              </td>
              <td class="text-center">
                <input class="form-control" (change)="onChangeEN($event.target.value)" placeholder="{{'Process Name [EN]' | translate}}" />
              </td>
              <td class="text-center" (click)="addNewNextProcess(data)" pTooltip="{{'Add Next Process' | translate}}"
                tooltipPosition="top" style="cursor:pointer;">
                <i class="fa fa-plus" aria-hidden="true"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="tab-pane" id="NextProcess" #unlistPane>
    <section class="parts_container mar-btm-40">
      <div class="row_title">{{'LINENUMBER' | translate}}</div>
    </section>
    <section class="part_search_bar row">
      <div class="col-md-6">
        <input class="searchBar" [(ngModel)]="searchText" placeholder="{{'Search Next Process' | translate}}">
      </div>
      <div class="offset-md-2 col-md-4">
        <button class="row_title_export btn btn-dark" (click)="exportCSV()">
          {{'Export Available Next process' | translate}}
        </button>
      </div>
    </section>
    <div class="row container mar-btm-40">
      <div class="offset-md-1 col-md-11">
        <!-- <p-dataTable [value]="lineNumberList_notDeleted | filter : searchText" [responsive]="true" [rows]="100"
          [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[50,100,500,1000]" [paginatorPosition]="'top'">
          <p-column field="lineNumber" header="{{'LINENUMBER' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'Search Next Process' | translate}}"></p-column>
          <p-column field="groupNumber" header="{{'Plant Name' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'Search Plant' | translate}}">
            <ng-template let-row="rowData" pTemplate="body">
              <select [(ngModel)]="row.groupNumber" (change)="onChangeGroup($event.target.value)" class="form-control">
                <option *ngFor="let opt of operationsGNumberList" value={{opt}}>
                  {{opt}}
                </option>
              </select>
            </ng-template>
          </p-column>
          <p-column field="" header="{{'Process Name [JP]' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'Search Process Name[JP]'| translate}}">
            <ng-template let-row="rowData" pTemplate="body">
              <input class="form-control" [(ngModel)]="row.processNameJp" (change)="onChangeJapName($event.target.value)"
                placeholder="{{'Process Name [JP]' | translate}}">
            </ng-template>
          </p-column>
          <p-column field="" header="{{'Process Name [EN]' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'Search Process Name[EN]' | translate}}">
            <ng-template let-row="rowData" pTemplate="body">
              <input class="form-control" [(ngModel)]="row.processNameEn" (change)="onChangeEngName($event.target.value)"
                placeholder="{{'Process Name [EN]' | translate}}">
            </ng-template>
          </p-column>
          <p-column field="" header="{{'SAVE' | translate}}&nbsp;&nbsp;|&nbsp;&nbsp;{{'DELETE' | translate}}"
            styleClass="text-center">
            <ng-template let-row="rowData" pTemplate="body">
              <span class="text-center col-md-5" (click)="saveNextProcess(row)" pTooltip="{{'SAVE' | translate}}"
                tooltipPosition="top" style="cursor:pointer;">
                <i class="fa fa fa-save fa-lg" aria-hidden="true"></i>
              </span>
              <span class="text-center col-md-5" (click)="deleteNextProcess(row)" pTooltip="{{'DELETE' | translate}}"
                tooltipPosition="top" style="cursor:pointer;">
                <i class="fa fa fa-trash fa-lg" aria-hidden="true"></i>
              </span>
            </ng-template>
          </p-column>
        </p-dataTable> -->
        <p-table [value]="lineNumberList_notDeleted | filter : searchText" [responsive]="true" [rows]="100"
          [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[50,100,500,1000]" [paginatorPosition]="'top'">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="lineNumber" style="width:20%">{{'LINENUMBER' | translate}}<p-sortIcon field="lineNumber"></p-sortIcon></th>
              <th pSortableColumn="groupNumber" style="width:20%">{{'Plant Name' | translate}}<p-sortIcon field="groupNumber"></p-sortIcon></th>
              <th pSortableColumn="processNameJp" style="width:20%">{{'Process Name [JP]' | translate}} <p-sortIcon field="processNameJp"></p-sortIcon></th>
              <th pSortableColumn="processNameEn" style="width:20%">{{'Process Name [EN]' | translate}} <p-sortIcon field="processNameEn"></p-sortIcon></th>
              <th style="width:20%">{{'SAVE' | translate}}&nbsp;&nbsp;|&nbsp;&nbsp;{{'DELETE' | translate}}</th>
          </tr>
            <tr>
                <th>
                    <p-columnFilter type="text" field="lineNumber"></p-columnFilter>
                </th>
                <th>
                  <p-columnFilter type="text" field="groupNumber"></p-columnFilter>
                </th>
                <th>
                  <p-columnFilter type="text" field="processNameJp"></p-columnFilter>
                </th>
                <th>
                  <p-columnFilter type="text" field="processNameEn"></p-columnFilter>
                </th>
                <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-value>
            <tr>
                <td>{{value.lineNumber}}</td>
                <td>
                  <select [(ngModel)]="value.groupNumber" (change)="onChangeGroup($event.target.value)" >
                    <option *ngFor="let opt of operationsGNumberList" value={{opt}}>
                      {{opt}}
                    </option>
                  </select>
                </td>
                <td><input class="form-control" [(ngModel)]="value.processNameJp" (change)="onChangeJapName($event.target.value)"
                  placeholder="{{'Process Name [JP]' | translate}}"></td>
                <td> <input class="form-control" [(ngModel)]="value.processNameEn" (change)="onChangeEngName($event.target.value)"
                  placeholder="{{'Process Name [EN]' | translate}}"></td>
                <td> 
                  <span class="text-center col-md-5" (click)="saveNextProcess(value)" pTooltip="{{'SAVE' | translate}}"
                  tooltipPosition="top" style="cursor:pointer;">
                    <i class="fa fa fa-save fa-lg" aria-hidden="true"></i>
                  </span>
                  <span class="text-center col-md-5" (click)="deleteNextProcess(value)" pTooltip="{{'DELETE' | translate}}"
                  tooltipPosition="top" style="cursor:pointer;">
                    <i class="fa fa fa-trash fa-lg" aria-hidden="true"></i>
                  </span>
                </td>
            </tr>
        </ng-template>
      </p-table>
      </div>
    </div>
  </div>

  <div class="tab-pane" id="DeletedNextProcess" #createPane>
    <section class="parts_container mar-btm-40">
      <div class="row_title">{{'Deleted Next Process' | translate}}</div>
    </section>
    <section class="part_search_bar row">
      <div class="col-md-6">
        <input class="searchBar" [(ngModel)]="searchTextDeleted" placeholder="{{'Search Next Process Deleted' | translate}}">
      </div>
      <!-- <div class="offset-md-2 col-md-4">
        <button class="row_title_export btn btn-dark" (click)="exportCSV()">
          Export&nbsp;Available&nbsp;Next process
        </button>
      </div> -->
    </section>
    <div class="row container mar-btm-40">
      <div class="offset-md-1 col-md-11">
        <p-table [value]="lineNumberList_Deleted | filter : searchTextDeleted" [responsive]="true" [rows]="100"
        [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[50,100,500,1000]" [paginatorPosition]="'top'">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="lineNumber" style="width:20%">{{'LINENUMBER' | translate}}<p-sortIcon field="lineNumber"></p-sortIcon></th>
              <th pSortableColumn="groupNumber" style="width:20%">{{'Plant Name' | translate}}<p-sortIcon field="groupNumber"></p-sortIcon></th>
              <th pSortableColumn="processNameJp" style="width:20%">{{'Process Name [JP]' | translate}}<p-sortIcon field="category"></p-sortIcon></th>
              <th pSortableColumn="processNameEn" style="width:20%">{{'Process Name [EN]' | translate}} <p-sortIcon field="quantity"></p-sortIcon></th>
              <th style="width:20%">{{'Undo Delete' | translate}}</th>
            </tr>
            <tr>
              <th>
                <p-columnFilter type="text" field="lineNumber"></p-columnFilter>
              </th>
              <th>
                <p-columnFilter type="text" field="groupNumber"></p-columnFilter>
              </th>
              <th>
                <p-columnFilter type="text" field="processNameJp"></p-columnFilter>
              </th>
              <th>
                <p-columnFilter type="text" field="processNameEn"></p-columnFilter>
              </th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-value>
            <tr>
                <td>{{value.lineNumber}}</td>
                <td>{{value.groupNumber}}</td>
                <td>{{value.processNameJp}}</td>
                <td>{{value.processNameEn}}</td>
                <td><div class="text-center" (click)="undoDelete(value)" pTooltip="{{'Undo Delete' | translate}}"
                  tooltipPosition="top" style="cursor:pointer;">
                  <i class="fa fa fa-undo fa-lg" aria-hidden="true"></i>
                </div></td>
            </tr>
          </ng-template>
        </p-table>
        <!-- <p-dataTable [value]="lineNumberList_Deleted | filter : searchTextDeleted" [responsive]="true" [rows]="100"
        [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[50,100,500,1000]" [paginatorPosition]="'top'">
          <p-column field="lineNumber" header="{{'LINENUMBER' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'Search Next Process' | translate}}"></p-column>
          <p-column field="groupNumber" header="{{'Plant Name' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'Search Plant' | translate}}">
          </p-column>
          <p-column field="processNameJp" header="{{'Process Name [JP]' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'Search Process Name[JP]'| translate}}">
          </p-column>
          <p-column field="processNameEn" header="{{'Process Name [EN]' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'Search Process Name[EN]' | translate}}">
          </p-column>
          <p-column field="" header="{{'Undo Delete' | translate}}">
            <ng-template let-row="rowData" pTemplate="body">
              <div class="text-center" (click)="undoDelete(row)" pTooltip="{{'Undo Delete' | translate}}"
                tooltipPosition="top" style="cursor:pointer;">
                <i class="fa fa fa-undo fa-lg" aria-hidden="true"></i>
              </div>
            </ng-template>
          </p-column>
        </p-dataTable> -->
      </div>
    </div>
  </div>
</div>